export const SESSION_TOKEN = "session-token";
export const MOBILE_SIZE = 769;
